import { customAlphabet } from "nanoid"

export const customNanoId = () => {
  const nanoid = customAlphabet('0123456789ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz', 18);
  return nanoid;
}